import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { EmployeeAttribute } from '../../entities/employee-attribute';
import { StaffAttributeCount } from '../../entities/staff-attribute-count';
import { StaffYears } from '../../entities/staff-years';
import { StaffCountService } from '../../services/staff-count.service';
import * as moment from 'moment'
import { UntypedFormControl } from '@angular/forms';
import { StaffDetailQuery } from '../../entities/staff-detatil-query';
import { result } from 'lodash';

@Component({
    selector: 'app-atrribute-count-view',
    templateUrl: './atrribute-count-view.component.html',
    styleUrls: ['./atrribute-count-view.component.scss'],
    standalone: false
})
export class AtrributeCountViewComponent implements OnInit {
  @Input() selectedAttributeData: EmployeeAttribute;
  @Input() selectedTipo: number;
  @Input() refreshAttribute: StaffDetailQuery;
  staffAttributeCount: StaffAttributeCount[];
  staffAttributeCountTotal: StaffAttributeCount[];
  @Output() newItemEvent = new EventEmitter<number>();

  nimatha: number;

  yearList: StaffYears[];
  year: number;
  private selectedDate: moment.Moment;
  startYear: number;
  endYear: number;
  currentYear: number;
  disabledPrevButton: boolean;
  disabledNextButton: boolean;
  intialCellValue: number;
  isDisabledTotalizar: boolean = false;
  isCompanyActive: boolean = true; 

  public yearControl: UntypedFormControl;


  constructor(private _staffCountService: StaffCountService) {
    this._staffCountService.staffDetail.subscribe(v => {
      this.getCompanyStaffAttributeCount(v.companyId, v.tipo, v.year, false);
    });
  }

  ngOnInit(): void {
    this.yearControl = new UntypedFormControl();
    this.disabledPrevButton = false;
    this.disabledNextButton = false;
    this.intialCellValue = 0;

    this.selectedDate = moment(new Date());
    this.yearControl.setValue(this.selectedDate.format('YYYY'));
    this.currentYear = Number(this.selectedDate.format('YYYY'));
    this._staffCountService.seletedTipo = this.selectedTipo;
    this.getAttributeYearList(this.selectedAttributeData.empresaId, this.selectedTipo);
    this._staffCountService.selectedYear = this.yearControl.value;
    //set default year as current year
    this.getCompanyStaffAttributeCount(this.selectedAttributeData.empresaId, this.selectedTipo, this.yearControl.value);
    this.getCompanyActive(this.selectedAttributeData.empresaId); 
  }

  getCompanyStaffAttributeCount(empresaId: any, tipo: any, year: any, isUpdated: boolean = false) {
    this._staffCountService.getCompanyStaffAttributeCount(empresaId, tipo, year)
      .subscribe(res => {
        let _lstIndex = res.result.length - 1;
        let tempArray = res.result.splice(0, _lstIndex);
        if (isUpdated != true) {
          this.staffAttributeCount = tempArray;
        }
        this.staffAttributeCountTotal = res.result;
      }, err => {
        console.error(err);
      });
  }

  getCompanyActive(empresaId: any) {
    if (!empresaId) return;

    this._staffCountService.isActive(empresaId).subscribe((res: boolean) => {
      this.isCompanyActive = res;
      this.isDisabledTotalizar = !this.isCompanyActive; 
    });
  }

  getAttributeYearList(empresaId: any, tipo: any) {
    this._staffCountService.getAttributeYearList(empresaId, tipo)
      .subscribe(res => {
        //get the start year and disabled the cuurent year
        const startYear = res.result[0];
        let value = JSON.stringify(startYear);
        if (value == undefined) {
          this.disabledNextButton = true;
          this.disabledPrevButton = true;
          return;
        }
        this.endYear = Number(this.selectedDate.format('YYYY'));
        this.startYear = Number(value.substring(8, 12));
        if (this.currentYear == this.endYear) {
          this.disabledNextButton = true;
        }
      }, err => {
        console.error(err);
      });
  }

  changeDate(navigationType: string): void {
    switch (navigationType) {
      case 'prev':
        this.selectedDate = moment(this.selectedDate.add(-1, 'years'));
        let seletedPrevYear = Number(this.selectedDate.format('YYYY'));
        this.disabledNextButton = false;
        //set the prev year margin as start year
        if (seletedPrevYear == this.startYear) {
          this.disabledPrevButton = true;
        }
        break;
      case 'next':
        this.selectedDate = moment(this.selectedDate.add(1, 'years'));
        let seletedNextYear = Number(this.selectedDate.format('YYYY'));
        this.disabledPrevButton = false;
        //set the next year margin as end year
        if (seletedNextYear == this.endYear) {
          this.disabledNextButton = true;
        }
        break;
      default:
        break;
    }
    this.yearControl.setValue(this.selectedDate.format('YYYY'));
    this._staffCountService.selectedYear = this.yearControl.value;
    this.getCompanyStaffAttributeCount(this.selectedAttributeData.empresaId, this.selectedTipo, this.yearControl.value);
  }



  getIntialCellValue(cellValue, companyId, year, month, attribute, tipo) {
    this.intialCellValue = cellValue;
    this._staffCountService.detailsAttributeSelected.emit({ companyId: companyId, year: year, month: month, attribute: attribute, tipo: tipo });
  }

  updateCell(cellValue, attribute, month) {
    if (cellValue) {
      this.updateCompanyAttributeStaffCount(this.selectedAttributeData.empresaId, attribute, this.selectedTipo, this.yearControl.value, month, cellValue);
    } else {
      this.deleteCompanyAttributeStaffCount(this.selectedAttributeData.empresaId, attribute, this.selectedTipo, this.yearControl.value, month);
    }
  }

  onEnterUpdateCell(cellValue, attribute, month) {
    if (cellValue) {
      this.updateCompanyAttributeStaffCount(this.selectedAttributeData.empresaId, attribute, this.selectedTipo, this.yearControl.value, month, cellValue);
    }
    this._staffCountService.detailsAttributeSelected.emit({ companyId: this.selectedAttributeData.empresaId.toString(), year: this.yearControl.value, month: month, attribute: attribute, tipo: this.selectedTipo.toString() });
  }

  updateCompanyAttributeStaffCount(companyId: any, attribute: string, tipo: any, year: string, month: string, staffCount: string): void {
    this._staffCountService.updateCompanyAttributeStaffCount(companyId, attribute, tipo, year, month, staffCount)
      .subscribe(res => {
        if (res.code === 0) {
          this.getCompanyStaffAttributeCount(this.selectedAttributeData.empresaId, this.selectedTipo, this.yearControl.value, true);
        } else {
        }
      }, err => {
        console.error(err);
      });
  }

  deleteCompanyAttributeStaffCount(companyId: any, attribute: string, tipo: any, year: string, month: string): void {
    this._staffCountService.deleteCompanyAttributeStaffCount(companyId, attribute, tipo, year, month).subscribe((res) => {
      if (res.code == 0) {
        this.getCompanyStaffAttributeCount(this.selectedAttributeData.empresaId, this.selectedTipo, this.yearControl.value, true);
      } else {
      }
    }, err => {
    });
  }

}
